<div class="withdrawal">
  <header class="withdrawal__header">
    <a class="withdrawal__brand" routerLink="/">FAC<span>3</span>LESS</a>
    <a class="withdrawal__back" routerLink="/">{{ 'withdrawal.back_home' | translate }}</a>
  </header>

  <div class="withdrawal__content">
    <div class="withdrawal__card">
      @if (reference(); as ref) {
        <!-- Confirmation view (request registered, email 1 sent) -->
        <h1>{{ 'withdrawal.success.title' | translate }}</h1>
        <p class="withdrawal__intro">{{ 'withdrawal.success.body' | translate }}</p>

        <div class="withdrawal__reference">
          <span class="withdrawal__reference-label">{{ 'withdrawal.success.reference_label' | translate }}</span>
          <span class="withdrawal__reference-value">#{{ ref }}</span>
        </div>

        <p class="withdrawal__note">{{ 'withdrawal.success.check_note' | translate }}</p>

        <a cButton color="primary" class="w-100" routerLink="/">
          {{ 'withdrawal.back_home' | translate }}
        </a>
      } @else {
        <h1>{{ 'withdrawal.title' | translate }}</h1>
        <p class="withdrawal__intro">{{ 'withdrawal.intro' | translate }}</p>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
            <input
              cFormControl
              formControlName="first_name"
              type="text"
              [placeholder]="'withdrawal.first_name_placeholder' | translate"
              [class.is-invalid]="firstNameCtrl().touched && firstNameCtrl().invalid"
              unassistedInput
            />
            @if (firstNameCtrl().touched && firstNameCtrl().invalid) {
              <c-form-feedback [valid]="false">
                {{ 'withdrawal.first_name_required' | translate }}
              </c-form-feedback>
            }
          </c-input-group>

          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilUser"></svg></span>
            <input
              cFormControl
              formControlName="last_name"
              type="text"
              [placeholder]="'withdrawal.last_name_placeholder' | translate"
              [class.is-invalid]="lastNameCtrl().touched && lastNameCtrl().invalid"
              unassistedInput
            />
            @if (lastNameCtrl().touched && lastNameCtrl().invalid) {
              <c-form-feedback [valid]="false">
                {{ 'withdrawal.last_name_required' | translate }}
              </c-form-feedback>
            }
          </c-input-group>

          <c-input-group class="mb-3">
            <span cInputGroupText><svg cIcon name="cilEnvelopeClosed"></svg></span>
            <input
              cFormControl
              formControlName="email"
              type="email"
              [placeholder]="'withdrawal.email_placeholder' | translate"
              [class.is-invalid]="emailCtrl().touched && emailCtrl().invalid"
              unassistedInput
            />
            @if (emailCtrl().touched && emailCtrl().invalid) {
              <c-form-feedback [valid]="false">
                @if (emailCtrl().errors?.['required']) {
                  {{ 'withdrawal.email_required' | translate }}
                }
                @if (emailCtrl().errors?.['email']) {
                  {{ 'withdrawal.email_invalid' | translate }}
                }
              </c-form-feedback>
            }
          </c-input-group>

          <div class="mb-3">
            <div id="mcaptcha-widget"></div>
            @if (captchaError()) {
              <small class="text-danger">{{ 'withdrawal.captcha_required' | translate }}</small>
            }
          </div>

          <button
            cButton
            color="primary"
            type="submit"
            class="w-100"
            [disabled]="!canSubmit()"
          >
            @if (loading()) {
              {{ 'withdrawal.submitting' | translate }}
            } @else {
              [ {{ 'withdrawal.submit' | translate }} ]
            }
          </button>

          @if (error()) {
            <div class="alert alert-danger mt-3" role="alert">{{ error() }}</div>
          }
        </form>
      }
    </div>
  </div>
</div>
